module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/items/items.component.css
// module id = ./src/app/pages/items/items.component.css
// module chunks = main